export enum QueryEnum {
  MAX_WIDTH_400 = "(max-width: 400px)",
  MAX_WIDTH_576 = "(max-width: 576px)",
  MAX_WIDTH_768 = "(max-width: 768px)",
  MAX_WIDTH_992 = "(max-width: 992px)",
  MAX_WIDTH_1200 = "(max-width: 1200px)",
  PREFERS_DARK_THEME = "(prefers-color-scheme: dark)",
  IS_TOUCH_DEVICE = "(hover: none) and (pointer: coarse)",
}
